module.exports = __webpack_public_path__ + "img/calendar_icon.d94199e0.svg";